<h2 class="section-title">{{ title }}</h2>
<div class="faq-list">
  @for (item of items; track item.question; let i = $index) {
    <div class="faq-item" [class.faq-item--expanded]="expanded()[i]">
      <button class="faq-question" (click)="toggle(i)" [attr.aria-expanded]="expanded()[i]">
        <span>{{ item.question }}</span>
        <icon [name]="expanded()[i] ? 'close' : 'navigate_next'" class="faq-icon"></icon>
      </button>
      <div class="faq-answer" [class.faq-answer--visible]="expanded()[i]">
        <div class="faq-answer__content" [innerHTML]="answerHtml(item)"></div>
      </div>
    </div>
  }
</div>
